import React, { lazy } from 'react';
import { RouteProps } from 'react-router-dom';
import Login from '../pages/presentation/auth/Login';
import DashboardPage from '../pages/presentation/dashboard/DashboardPage';

const presentation: RouteProps[] = [
	{
		path: '/',
		element: <Login />,
	},
	{
		path: '/dashboard',
		element: <DashboardPage />,
	},
	{
		path: '/auth-pages/login',
		element: <Login />,
	},
];
const contents = [...presentation];

export default contents;
